/* istanbul ignore file */
import { number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CourseOfTenantCouponUsageParser = 
/* #__PURE__ */ parsers.object([
    ['id', codecNumber],
    ['tenantId', codecString, 'tenant_id'],
    ['name', codecString],
]);
export class CourseOfTenantCouponUsage extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CourseOfTenantCouponUsageParser.decode(input).map(res => new CourseOfTenantCouponUsage(res));
    }
    static unsafeDecode(input) {
        return CourseOfTenantCouponUsage.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CourseOfTenantCouponUsageParser.encode(data);
    }
    static schema() {
        return CourseOfTenantCouponUsageParser.schema();
    }
}
